module.exports = __webpack_public_path__ + "static/media/spain_id_card_myinfo@2x.a300e3de.png";